<div class="card_container" >
    <h4 class="title_card">{{dropdownCard.title}}</h4>
    <div class="cardInfo_container">
        <img src="{{dropdownCard.icon.src}}" alt="{{dropdownCard.icon.alt}}">
        <div>
            <p *ngIf="hiddenServ">Importe y servicios 
                <button (click)='showServ()'>
                    <img class="chev" src="../../../assets/img/chevdown.png" alt="chevdown">
                </button>
            </p>
            <p *ngIf="!hiddenServ">Importe y servicios
                <button (click)="hideServ()">
                    <img class="chev" src="../../../assets/img/chevup.png" alt="chevup">
                </button> 
            </p>
            <p *ngIf="hiddenExe">Fase de ejecución 
                <button (click)="showExe()">
                    <img class="chev" src="../../../assets/img/chevdown.png" alt="chevdown"> 
                </button>
            </p>
            <p *ngIf="!hiddenExe">Fase de ejecución
                <button (click)="hideExe()">
                    <img class="chev" src="../../../assets/img/chevup.png" alt="chevup">
                </button>
            </p>
        </div>
    </div>
    <hr *ngIf="hiddenServ === false">
    <div class="text_drop" [hidden]="hiddenServ">       
        <p>{{dropdownCard.dropOne.text}}</p>
        <p *ngFor="let item of dropdownCard.dropOne.textArray">{{item}}</p>
        <ul *ngFor="let item of dropdownCard.dropOne.bullet">
            <li>{{item}}</li>
        </ul>
    </div>
    <hr *ngIf="hiddenExe ===false">
    <div id="Exe" class="text_dropTwo" [hidden]="hiddenExe" *ngFor="let item of dropdownCard.dropTwo" >
        <p>{{item}}</p>
    </div>
</div>

